import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SetupBanner from './SetupBanner';

const LOGO = "/images/smart-device-copy.png";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="site-logo" onClick={() => setOpen(false)}>
          <img src={LOGO} alt="Smart Device Assistant" />
        </Link>
        <button className="nav-toggle" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
        <nav>
          <ul className={`site-nav${open ? ' open' : ''}`}>
            {[
              { label: 'Home', to: '/', end: true },
              { label: 'About Us', to: '/about-us' },
              { label: 'Contact Us', to: '/contact-us' },
              { label: 'Disclaimer', to: '/disclaimer' },
            ].map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <>
      {/* Disclaimer bar — sits ABOVE the footer */}
      <div className="pre-footer-disclaimer">
        <div className="pre-footer-disclaimer-inner">
          <strong>Disclaimer:</strong> Users are advised to read the disclaimer carefully and thoroughly.
          Smart Device Assistant aims to provide you detailed information about Printer, Extender, Arlo
          and smart home devices for your knowledge and help you fix any issue you are facing while using
          these devices. Smartdeviceassistant.com is not associated with any brand or is not a part of
          any Associate program or affiliate advertising program, and we don't promote any product,
          brand, or software. Also, we don't provide access to any outside links. If you've found any
          external link to our website, you can feel free to inform us, and we will remove it quickly.
          At Smartdeviceassistant, brand names and product logos are just for representation purpose.
          We are not responsible for any outside content or links.
        </div>
      </div>

      <footer className="site-footer">

        {/* Logo bar — sits ABOVE the column grid */}
        <div className="footer-logo-bar">
          <Link to="/" className="footer-logo">
            <img src={LOGO} alt="Smart Device Assistant" />
          </Link>
        </div>

        <div className="footer-top">

          {/* Column 1 — About */}
          <div className="footer-about">
            <p>
              Welcome to Smartdeviceassistant.com. The information provided on this website is intended
              to offer users helpful, step-by-step guides for setting up printers and troubleshooting
              common printing issues.{' '}
              <Link to="/about-us">Read More</Link>
            </p>
          </div>

          {/* Column 2 — Location */}
          <div className="footer-location">
            <h4>Location</h4>
            <p>Address: 11201, North Tatum , Phoenix,AZ, United States 85028</p>
            <strong>Contact</strong>
            <a href="mailto:contact@smartdeviceassistant.com">contact@smartdeviceassistant.com</a>
          </div>

          {/* Column 3 — Useful Links */}
          <div className="footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><Link to="/fix-an-offline-printer">Printer Offline</Link></li>
              <li><Link to="/how-to-setup-your-device">Printer Setup</Link></li>
              <li><Link to="/4-methods-of-scanning-documents">Scanner Setup</Link></li>
            </ul>
          </div>

          {/* Column 4 — Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/privacypolicy">Privacy Policy</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
              <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

        </div>

        {/* Bottom bar — copyright only */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            Copyright &copy; 2026 Smartdeviceassistant |{' '}
            <Link to="/privacypolicy">Privacy Policy</Link> |{' '}
            <Link to="/terms-conditions">Terms &amp; Conditions</Link> |{' '}
            <Link to="/refund-policy">Refund Policy</Link> |{' '}
            <Link to="/contact-us">Contact</Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default function Layout({ children, bannerTitle }) {
  return (
    <div className="page-wrapper">
      <SetupBanner pageTitle={bannerTitle} />
      <Header />
      <main id="content">
        {children}
      </main>
      <Footer />
    </div>
  );
}
